import {ApiService} from "../index";
import {APIConfig} from "../../../constants";

const getUserList = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.USER_LIST.METHOD](APIConfig.USER_LIST.URL, payload);
}

const getUserListLite = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.USER_LIST_LITE.METHOD](APIConfig.USER_LIST_LITE.URL, payload);
}

const GetSystemSettingsDetails = () => {
    return ApiService[APIConfig.SYSTEM_SETTINGS_DETAILS.METHOD](APIConfig.SYSTEM_SETTINGS_DETAILS.URL);

}

const UserService = {
    getUserList,
    getUserListLite,
    GetSystemSettingsDetails
}

export default UserService;
